import React from "react";
import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

// Styled component for dark tooltip
const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#2b2b2b",
    color: "#fff",
    fontSize: "0.75rem",
    padding: "8px 10px",
    borderRadius: 6,
    border: "1px solid #2b2b2b",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#2b2b2b",
  },
}));

// Export reusable component
export const DarkTooltip: React.FC<TooltipProps> = (props) => {
  return <StyledTooltip {...props} />;
};

// Fix for isolatedModules (optional but safe)
export {};